module.exports = __webpack_public_path__ + "e5fdd87831a20b45fb45c4524707caed.gif";